import React, { useEffect } from 'react'

const useClickOutside = (ref, onClickOutside, clickMatches = false) => {
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				(ref.current && !ref.current.contains(event.target)) ||
				(ref.current && clickMatches && ref.current.isSameNode(event.target))
			) {
				onClickOutside()
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [ref, onClickOutside, clickMatches])
}

export default useClickOutside
